import { useEffect, useRef } from "react";

/**
 * Hook para utilização em contextos de necessidade de verificação
 * de mudança de um estado.
 * 
 * @param {*} value Valor inicial
 * @returns Valor anterior antes do estado ser atualizado.
 */
export const usePreviousValue = function (value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
